export const muiStyles = () => ({
    root: {
        position: 'relative' as const,
        height: '100%'
    },
    exportButton: {
        position: 'absolute' as const,
        width: '2rem',
        top: '1rem',
        right: '.7rem',
        zIndex: 4
    },
    exportIcon: {
        height: '1rem',
        width: '1.5rem'
    }
});